import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { Box, Text, Paragraph, Button, /*Layer,*/ TextInput } from 'grommet';
import { withRouter } from 'react-router-dom';
import { loader } from '../Utils/Utility';
import ModalErrorTimeout from './ModalErrorTimeout';
import { SendOtpNewTelCtrl } from '../Controllers/Account/SendOtpNewTelCtrl';
import { StatusInfo } from 'grommet-icons';

class Error extends React.Component {

    render() {

        return (

            <Box>
                {this.props.testo.length > 0 ? <Text className='error'>{this.props.testo}</Text> : <div className='margin-error'></div>}
            </Box>
        );
    }
}

class ModifyTelephoneStep2 extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props)
        this.state = {
            modalMessage: false,
            status: '',
            otp: '',
            dataNewTel: '',
            telephone:'',
            next: this.props.values.dataNewOTP,
            showTimeoutModal: false,
            loading: false
        }

    }

    sendNewTelephone = () => {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        var self = this;
        self.setState({loading: true});
        SendOtpNewTelCtrl(function (data) {
            self.setState({
                dataNewTel: data,
                loading: false
            }, function(){ 
                if( self.state.dataNewTel === true){
                    self.saveAndContinue();
                }
            })
        }, function (error) {
            self.setState({
                status: error,
                loading: false
            }, function(){
                if(self.state.status === 500 || self.state.status === 400 || self.state.status === 404 || self.state.status === 403){
                    self.props.history.push({
                        pathname: '/ErrorPage',
                        state: self.state
                    })  
                } else if (self.state.status === 401) {
                    this.setState({
                        showTimeoutModal: true
                    })
                    // logout();
                    // self.props.history.push({
                    // pathname: '/login'
                    // })
                } 
            })
        }, this.state.telephone, token, ids)
    }

    saveAndContinue = () => {
        this.props.nextStep();
    }

    back = (e) => {
        e.preventDefault();
        this.props.prevStep();
    }

    setTelephone = (e) => {
        var tel = e.target.value;
        this.setState({
            telephone: tel,
        }, function () {
            this.props.disableButton(tel)
            sessionStorage.setItem("newTelephone", this.state.telephone)
        })
    }

    render() {

        return (

            <Box className='contentbox'>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}

                <Box direction='column' align='center'>

                    <Box direction='row'>
                        <h1 className='fixFont' level='1' style={{ marginBottom: '50px' }}>Modifica telefono cellulare</h1>
                        <Text className='titlehome' style={{ marginBottom: '5px' }}></Text>
                    </Box>
                    <Box style={{ height: '280px' }}>
                        <Box direction='row' justify='center'>
                            <Paragraph className='textParagraph'>Inserisci il tuo <span className='bold'>nuovo numero di cellulare</span></Paragraph>
                        </Box>
                        <Box direction='column' margin='small' style={{ marginTop: '50px' }}>
                            <Text className='label'>NUMERO DI TELEFONO CELLULARE</Text>
                            <div style={{ display:'inline-flex', width: '300px' }}>
                                <Box direction='row'>
                                    {/*<Text style={{ margin: '8px 30px 0 0', fontFamily: 'Segoe UI Semibold', fontSize: '15px' }}>+39</Text> */}<TextInput id='otp' size='medium' className='inputFormdisp inputNumberNoArrow' style={{ width: '270px' }} onChange={this.setTelephone} maxLength={15} />
                                    <div class="tooltipPwd"><StatusInfo className="iconTooltip" aria-label="Informazioni sul nuovo numero di telefono"/>
                                        <span class="tooltiptext">
                                        Indicare sempre il prefisso internazionale. Es: +39 per l'Italia
                                        </span>
                                    </div>
                                </Box>
                            </div>
                            <Error testo={this.props.values.msgError} />
                        </Box>
                    </Box>
                    <Box className='informativa' justify='center' direction='row'>
                        <Button className='btnform' style={{ width: '170px', margin: '0 30px 0 0' }} onClick={ this.back }>INDIETRO</Button>
                        <Button className={this.props.values.buttonState ? 'btnform disabled' : 'btnform'} disabled={this.props.values.buttonState} style={{ width: '170px' }} onClick={this.sendNewTelephone}>AVANTI</Button>
                    </Box>
                    {this.state.loading ? loader : ''}

                </Box>
            </Box>

        )
    }
}

export default ModifyTelephoneStep2 = withRouter(ModifyTelephoneStep2);
